package com.appsyde.shared.modules.ai.data.dto

import kotlinx.serialization.Serializable

@Serializable
data class AiGenerateRequestV2(
    val messageId: String,
    val force: Boolean = false
)
